export function tengoRol(roles) {
    let tengoRol = false;

    let user = JSON.parse(localStorage.getItem('userAutopartes'));
    if (user !== undefined && user.roles) tengoRol = user.roles.some(rol => roles.includes(rol));

    return tengoRol;
}

export const traerMisRoles = () => {

    let user = JSON.parse(localStorage.getItem('userAutopartes'));
    if (user !== undefined && user.roles) return user.roles;
    return [];
}


export const estadosProductos = [
    {id: 'ACTIVA', descripcion: 'ACTIVA'},
    {
        id: 'PAUSADA',
        descripcion: 'PAUSADA'
    },
    {id: 'FINALIZADA', descripcion: 'FINALIZADA'}];

export const TIPO_CONVERSACION = {
    NUEVO_VENDEDOR: 'NUEVO_VENDEDOR',
    NUEVA_MARCA: 'NUEVA_MARCA',
    PRODUCTO: 'PRODUCTO',
    VENDEDOR: 'VENDEDOR',
    GENERAL: 'GENERAL'
}

export const ESTADO_VENTA = {
    PENDIENTE_PAGO: 'PENDIENTE_PAGO',
    CANCELADA: 'CANCELADA',
    PENDIENTE_ENTREGA: 'PENDIENTE_ENTREGA',
    PAGADA: 'PAGADA',
    FINALIZADA: 'FINALIZADA'
}

export const ESTADO_PRODUCTO = {
    ACTIVA: 'ACTIVA',
    PAUSADA: 'PAUSADA',
    FINALIZADA: 'FINALIZADA'
}


export const TIPO_IMAGEN = {
    GENERAL: 'GENERAL',
    FRENTE: 'FRENTE',
    ATRAS: 'ATRAS',
    CONDUCTOR: 'CONDUCTOR',
    ACOMPANIANTE: 'ACOMPANIANTE',
    BANNER_PUBLICACIONES: 'BANNER_PUBLICACIONES'
}

export const MEDIO_PAGO = {
    MERCADO_PAGO: 'MERCADO_PAGO',
    TRANSFERENCIA: 'TRANSFERENCIA',
    EFECTIVO: 'EFECTIVO'
}



export const Role = {
    ADMIN: {name: 'ADMIN'},
    CLIENTE: {name: 'CLIENTE'},
    VENDEDOR: {name: 'VENDEDOR'}
}

export const ERR = {
    REQ: 'Requerido',
    NUM: "Solo números, decimales separados por '.'",
    MIN: 'Minimo',
    MAX: 'Máximo'
}

export const Estado = {
    ABIERTO: 1,
    CERRADO: 2
}

export const TIPO_EXPORT = {
    CANDADO: 1,
    SITIO: 2,
    USUARIO: 3
}

export const TIPO_ENVIO = {
    SIN_ENVIO: 'SIN_ENVIO',
    ENVIO_A_COORDINAR: 'ENVIO_A_COORDINAR'
}
//  alternador, burro, computadora
export const TIPO_REPUESTO = {
    AUTO_DESARMADERO: 'Baja',
    MOTOR_04: 'Motor 04',
    TURBO_COMPRESOR: 'Turbo compresor',
    VOLANTE_MOTOR: 'Volante de motor',
    BOBINA_ENCENDIDO: 'Bobina de encendido',
    BOMBA_AGUA: 'Bomba de agua',
    ALTERNADOR: 'Alternador',
    BURRO_ARRANQUE: 'Burro de arranque'
}

export const TIPO_REPUESTO_ID = {
    AUTO_DESARMADERO: 34,
    MOTOR_04: 20
}

